// extracted by mini-css-extract-plugin
module.exports = {"tagsWrapper":"chartTags_tagsWrapper__-mihZ","tag":"chartTags_tag__2ftVX","square":"chartTags_square__qo90Q","showMore":"chartTags_showMore__3OXfE"};